import type { ReplaceTestIdWithAppOne } from '../../const/testIds';

import type { AppBaseRadioItemProps } from './AppBaseRadioItem';
import { AppBaseRadioItem } from './AppBaseRadioItem';

export type AppRadioItemProps = ReplaceTestIdWithAppOne<AppBaseRadioItemProps>;

export const AppRadioItem = (props: AppRadioItemProps) => (
	<AppBaseRadioItem {...props} />
);
